import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { FormFieldHelpers as Form } from '../../../../../helpers';
import { currency } from './../../../../../helpers/';

class ReceiptMemberDetails extends React.Component {

    componentDidMount () {
        this.props.initialize({
            "full_name": `${ this.props.account.first_name } ${ this.props.account.last_name }`,
            "company": this.props.account.company && this.props.account.company,
            "vat": this.props.account.vat && this.props.account.vat,
            "company_number": this.props.account.company_number && this.props.account.company_number,
            "email_address": this.props.account.email_address,
            "phone": this.props.account.phone_number,
        });
    }

    render () {
        return (
            <div className="">
                <form className="row">
                    <div className="col-xs-12">
                        <div className="row">
                            <div className="field-box col-xs-12">
                                <Field
                                    name="full_name"
                                    placeholder="Full name"
                                    component={Form.textField}
                                />
                            </div>
                        </div>
                        <div className="row">
                            <div className="field-box-nolabel helper-text col-xs-12">
                                <Field
                                    name="company"
                                    placeholder="Company"
                                    component={Form.textField}
                                />
                                <small>(leave blank if not applicable)</small>
                                <br/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="field-box-nolabel helper-text col-xs 12 col-sm-6">
                                <Field
                                    name="vat"
                                    placeholder={ `${ currency.taxType() } Number` }
                                    component={Form.textField}
                                />
                                <small>(leave blank if not applicable)</small>
                                <br/>
                            </div>
                            <div className="field-box-nolabel helper-text col-xs 12 col-sm-6">
                                <Field
                                    name="company_number"
                                    placeholder="Company number"
                                    component={Form.textField}
                                />
                                <small>(leave blank if not applicable)</small>
                                <br/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="field-box-nolabel col-xs 12 col-sm-6">
                                <Field
                                    name="email_address"
                                    placeholder="Email address"
                                    component={Form.textField}
                                />
                            </div>
                            <div className="field-box-nolabel col-xs 12 col-sm-6">
                                <Field
                                    name="phone"
                                    placeholder="Phone number"
                                    component={Form.textField}
                                />
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        )
    }
}

ReceiptMemberDetails = reduxForm( { form: "receipt_member_details" } )( ReceiptMemberDetails );

export default ReceiptMemberDetails;



// WEBPACK FOOTER //
// src/client/components/site/features/account/transactionHistory/ReceiptMemberDetails.js